/**
 * Module Federation 1.5 Runtime Plugin
 *
 * This plugin provides lifecycle hooks for Module Federation runtime operations.
 * The beforeInit hook allows you to modify or inspect configuration before
 * the remote container is initialized.
 */

export default function runtimePlugin() {
  return {
    name: "custom-runtime-plugin",

    beforeInit(args) {      
      if (args.options.remotes) {
        console.log(`[SurveyPlayer: Runtime Plugin] Entry points set to DPM config`);
        Object.keys(args.options.remotes).forEach((remoteName) => {
          const remote = args.options.remotes[remoteName];
          const importPath = globalThis.__DPM_Federation__.configuration.imports[remote.alias];
          
          // Check if importPath is already a full URL (starts with http:// or https://)
          const isFullUrl = /^https?:\/\//i.test(importPath);
          
          args.options.remotes[remoteName].entry = isFullUrl
            ? importPath
            : window.location.origin + importPath;
        });
      }
      return args;
    },
  };
}
